<template>
  <RouterView
    @onStartEvent="onStartEvent"
    @onEndEvent="onEndEvent"
  />
</template>

<script>
import format from '@/utils/format';
let eventTime;

export default {
  name: 'Index',
  methods: {
    onStartEvent () {
      eventTime = Math.trunc(Date.now() / 1000);
    },
    onEndEvent () {
      this.$root.trackEvent({
        eventCategory: 'MobileAppListing',
        eventAction: 'ÜrünListesiDropdownMenüTekilÜrünEklemeBasarılı',
        eventLabel: format.formatTime(Math.trunc(Date.now() / 1000) - eventTime),
      });
      this.$root.trackEvent({
        eventCategory: 'Time Difference',
        eventAction: 'SPM - Tekil Ürün Oluştur',
        eventLabel: format.formatTime(Math.trunc(Date.now() / 1000) - eventTime),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .container {
    position: relative;
    padding:0 15px;
    padding-bottom: 80px;
    min-height: calc(100vh);
  }
  ::v-deep {
    section {
      display: block;
      margin-bottom: 25px;
      .header {
        font-size: 16px;
        color: #273142;
        font-weight: 500;
        margin-bottom: 15px;
      }
      .row {
        margin-bottom: 15px;
        .label {
          font-size: 12px;
          color: #6E7787;
          font-weight: 500;
          margin-bottom: 5px;
          display: block;
          .required {
            color: #FF5043;
          }
        }
        .form-control {
          border-color: rgb(222, 224, 235);
        }
        .is-invalid > .input-group .form-control,
        .form-control.is-invalid {
          border-color: #FF5043;
        }

        & .invalid-feedback {
          font-size: 11px;
          color: #FF5043;
        }
      }
    }
    .button-wrapper{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      padding: 15px;
      margin-top: 15px;
      background: #ffffff;
      border-radius: 10px 10px 0 0;
      box-shadow: 0 -5px 7px rgba(39, 49, 66, 0.1);

      display: flex;
      .btn {
        flex: 1;
        & + .btn{
          margin-left: 10px;
        }
      }
    }
  }
</style>
